import { globalVariables } from "helper/globalVariables";
import { useForm } from "react-hook-form";
import { judgeBasicDetailsResolver } from "validators/UserValidation";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "helper/apolloConfig";
import AuthLayout from "shared/Components/authLayout";
import { useDispatch, useSelector } from "react-redux";
import { setJudgeDetails } from "redux/features/judgeSlice/judgeSlice";
import { TextInput } from "shared/Components/textInput";
import { Button } from "shared/Components/button";
import { registerJudgeMutation } from "redux/features/judgeSlice/judgeGql";
import { PhoneInput } from "shared/Components/phoneInput";

export const BasicDetails = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: judgeBasicDetailsResolver,
    defaultValues: {
      phoneNumber: "",
      distance: 0,
      address: "",
    },
  });
  const modalRef = useRef();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [loading, setLoading] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state);

  const handleSignup = async (credentials) => {
    const judgeDetails = auth?.judgeReducer?.judgeDetails;
    const { username, email, password } = judgeDetails || {};
    const name = username?.split(" ");
    const firstName = name?.[0];
    const lastName = name?.[1];
    const payload = {
      first_name: firstName,
      email: email,
      password: password,
      location_address: credentials?.address,
      phone_number: credentials?.phoneNumber,
      distance_travel: credentials.distance?.toString(),
    };
    payload.last_name = lastName ?? " ";

    setLoading(true);
    try {
      const result = await client.mutate({
        mutation: registerJudgeMutation,
        variables: { data: payload },
      });

      modalRef.current.openModal();
      if (result?.data?.registerJudge) {
        setApiData({
          ...apiData,
          title: globalVariables.signUpSuccessful,
          desc: globalVariables.judgeApplicationSubmitted,
          type: "success",
        });
      }
      setLoading(false);
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
      setLoading(false);
    }
  };

  const onCloseModal = () => {
    if (apiData.type === "success") {
      navigate("/login");
      reset();
      dispatch(setJudgeDetails(null));
    }
  };

  return (
    <AuthLayout ref={modalRef} apiData={apiData} onCloseModal={onCloseModal}>
      <span className="pt-4 text-gray-900 font-semibold text-3xl">
        {globalVariables.basicDetails}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base max-[358px]:w-[90%]">
        {globalVariables.pleaseFillDetailsJudge}
      </span>
      <div className="mt-8" />
      <form
        onSubmit={handleSubmit(handleSignup)}
        className="flex flex-col justify-center items-center max-[400px]:w-[90%]"
      >
        <PhoneInput
          name="phoneNumber"
          placeholder={globalVariables.enterPhoneNumber}
          errorMsg={errors.phoneNumber?.message}
          label={globalVariables.phoneNumber}
          value={watch("phoneNumber")}
          onChange={(e) => setValue("phoneNumber", e.target.value)}
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
        />
        <div className="mt-6" />
        <TextInput
          register={register}
          name="distance"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.distanceReadyTravel}
          placeholder={globalVariables.enterDistanceReady}
          errorMsg={errors.distance?.message}
        />
        <div className="mt-6" />
        <TextInput
          register={register}
          name="address"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.address}
          placeholder={globalVariables.enterYourAddress}
          errorMsg={errors.address?.message}
          textTransform="normal-case"
        />
        <div className="mt-6" />
        <Button
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.continue}
          disabled={loading}
        />
      </form>
    </AuthLayout>
  );
};
